import { gql } from "@apollo/client";

export const MICROPROGRAMMING_PREVIEW_QUERY = gql`
  query MicroprogrammingPreview(
    $scenarioId: ID!
    $originId: ID!
    $input: MicroprogrammingPreviewInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      microprogrammingPreview(input: $input) {
        sections {
          id
          code
          isPreview
          component {
            id
            code
          }
          sessions {
            id
            blocksCount
            isPreview
            classrooms {
              id
              code
              name
            }
            instructors {
              id
              code
              name
            }
            assignment {
              day
              blocks {
                id
                startingTime
                endingTime
              }
              intervals {
                id
                name
              }
              blockRange {
                start {
                  id
                  day
                  startingTime
                }
                end {
                  id
                  endingTime
                }
              }
            }
          }
        }
        validationErrors {
          code
          message
        }
      }
    }
  }
`;
